import NAV from './nav'

fetch(' /data/nav.json')
  .then(response => response.json())
  .then(data => {
    new NAV(data)
  });
